"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

function ContentsList({ contentsList = [] }) {
  return (
    <motion.div initial={{ opacity: 0, y: 20, scale: 0.95 }} whileInView={{ opacity: 1, y: 0, scale: 1 }} transition={{ duration: 1, type: "spring", stiffness: 100 }} viewport={{ once: true }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 justify-items-center xl:gap-0 mt-0 md:mt-8 lg:mt-12 px-4 sm:px-0">
      {contentsList.map((contents, index) => (
        <Link href={"/contents/" + contents.attributes.slug} key={index} className="w-fit">
            <div className="flex flex-col w-full md:w-[345px] lg:w-[310px] h-[322px] xl:w-[280px] 2xl:w-[345px] p-6 rounded-2xl shadow-custom border-[#F3F3F3] border mb-5 transition-all duration-700 hover:scale-105">
                {contents.attributes.Image?.data?.[0]?.attributes?.url ? (
                    <Image src={process.env.NEXT_PUBLIC_BACKEND_BASE_URL + contents.attributes.Image.data[0].attributes.url} alt={contents.attributes.Image.data[0].attributes.alternativeText || "Thumbnail Image"}
                        className="object-cover rounded-xl border border-[#f2f2f2] h-[130px] w-full"
                        width={5000}
                        height={5000}
                    />
                ) : (
                    <span>No Image Available</span>
                )}
                <h2 className="text-base font-semibold md:font-medium md:text-xl text-[#333333] mt-3">
                    {contents.attributes.Title}
                </h2>
                <span className="text-[#A8A6AC] text-[13px] line-clamp-4">
                    {contents.attributes.Description}
                </span>
                <div className="flex items-end justify-end">
                    <div className="flex items-center justify-end mt-2">
                        <span className="text-[#00CC00] text-[14px] flex items-center font-bold hover:text-[#00CC00]/80">
                            Цааш унших
                            <ArrowRight size={16} className="text-[#00CC00]" />
                        </span>
                    </div>
                </div>
            </div>
        </Link>
      ))}
    </motion.div>
  );
}

export default ContentsList;
